import { emptySplitApi as api } from "../../emptyApi";
const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    apiAdminV1SurveyQuestionList: build.query<
      ApiAdminV1SurveyQuestionListApiResponse,
      ApiAdminV1SurveyQuestionListApiArg
    >({
      query: (queryArg) => ({
        url: `/api/admin/v1/survey-question/`,
        params: {
          search: queryArg.search,
          survey_type: queryArg.surveyType,
        },
      }),
    }),
    apiAdminV1SurveyQuestionCreate: build.mutation<
      ApiAdminV1SurveyQuestionCreateApiResponse,
      ApiAdminV1SurveyQuestionCreateApiArg
    >({
      query: (queryArg) => ({
        url: `/api/admin/v1/survey-question/`,
        method: "POST",
        body: queryArg.surveyQuestion,
      }),
    }),
    apiAdminV1SurveyQuestionRetrieve: build.query<
      ApiAdminV1SurveyQuestionRetrieveApiResponse,
      ApiAdminV1SurveyQuestionRetrieveApiArg
    >({
      query: (queryArg) => ({
        url: `/api/admin/v1/survey-question/${queryArg.id}/`,
      }),
    }),
    apiAdminV1SurveyQuestionUpdate: build.mutation<
      ApiAdminV1SurveyQuestionUpdateApiResponse,
      ApiAdminV1SurveyQuestionUpdateApiArg
    >({
      query: (queryArg) => ({
        url: `/api/admin/v1/survey-question/${queryArg.id}/`,
        method: "PUT",
        body: queryArg.surveyQuestion,
      }),
    }),
    apiAdminV1SurveyQuestionDestroy: build.mutation<
      ApiAdminV1SurveyQuestionDestroyApiResponse,
      ApiAdminV1SurveyQuestionDestroyApiArg
    >({
      query: (queryArg) => ({
        url: `/api/admin/v1/survey-question/${queryArg.id}/`,
        method: "DELETE",
      }),
    }),
    apiAdminV1SurveyQuestionDuplicateCreate: build.mutation<
      ApiAdminV1SurveyQuestionDuplicateCreateApiResponse,
      ApiAdminV1SurveyQuestionDuplicateCreateApiArg
    >({
      query: (queryArg) => ({
        url: `/api/admin/v1/survey-question/${queryArg.id}/duplicate/`,
        method: "POST",
        body: queryArg.surveyQuestionDuplicate,
      }),
    }),
  }),
  overrideExisting: false,
});
export { injectedRtkApi as adminApi };
export type ApiAdminV1SurveyQuestionListApiResponse =
  /** status 200  */ SurveyQuestionRead[];
export type ApiAdminV1SurveyQuestionListApiArg = {
  /** Optional search across name field */
  search?: string;
  /** Filter by survey type (e.g. 1 = Culture, 2 = Mood, etc) */
  surveyType?: number;
};
export type ApiAdminV1SurveyQuestionCreateApiResponse =
  /** status 201  */ SurveyQuestionRead;
export type ApiAdminV1SurveyQuestionCreateApiArg = {
  surveyQuestion: SurveyQuestion;
};
export type ApiAdminV1SurveyQuestionRetrieveApiResponse =
  /** status 200  */ SurveyQuestionRead;
export type ApiAdminV1SurveyQuestionRetrieveApiArg = {
  /** A unique integer value identifying this survey question. */
  id: number;
};
export type ApiAdminV1SurveyQuestionUpdateApiResponse =
  /** status 200  */ SurveyQuestionRead;
export type ApiAdminV1SurveyQuestionUpdateApiArg = {
  /** A unique integer value identifying this survey question. */
  id: number;
  surveyQuestion: SurveyQuestion;
};
export type ApiAdminV1SurveyQuestionDestroyApiResponse =
  /** status 204  */ Blob;
export type ApiAdminV1SurveyQuestionDestroyApiArg = {
  /** A unique integer value identifying this survey question. */
  id: number;
};
export type ApiAdminV1SurveyQuestionDuplicateCreateApiResponse =
  /** status 201  */ SurveyQuestionRead;
export type ApiAdminV1SurveyQuestionDuplicateCreateApiArg = {
  /** A unique integer value identifying this survey question. */
  id: number;
  surveyQuestionDuplicate: SurveyQuestionDuplicate;
};
export type SurveyQuestionStatusEnum = 1 | 2 | 3;
export type SurveyTypeEnum = 1 | 2 | 3 | 5 | 6 | 7 | 8 | 9 | 10 | 11;
export type SurveyQuestion = {
  name: string;
  status?: SurveyQuestionStatusEnum;
  survey_type?: SurveyTypeEnum;
  url_location?: string | null;
  sort_order: number;
  questions?: any | null;
};
export type SurveyQuestionRead = {
  id: number;
  name: string;
  status?: SurveyQuestionStatusEnum;
  survey_type?: SurveyTypeEnum;
  url_location?: string | null;
  sort_order: number;
  questions?: any | null;
  created_by: number | null;
  created_at: string;
  updated_at: string;
};
export type SurveyQuestionDuplicate = {
  name: string;
};
export const {
  useApiAdminV1SurveyQuestionListQuery,
  useApiAdminV1SurveyQuestionCreateMutation,
  useApiAdminV1SurveyQuestionRetrieveQuery,
  useApiAdminV1SurveyQuestionUpdateMutation,
  useApiAdminV1SurveyQuestionDestroyMutation,
  useApiAdminV1SurveyQuestionDuplicateCreateMutation,
} = injectedRtkApi;
